'use client'

import { useParams, usePathname, useSearchParams } from 'next/navigation'
import { useTranslation } from 'react-i18next'

export function useRouterContext() {
  const { i18n } = useTranslation()
  const pathname = usePathname()
  const params = useParams()
  const searchParams = useSearchParams()
  const asPath = pathname + (searchParams ? `?${searchParams}` : '')
  const locale = i18n.language

  return {
    pathname,
    params,
    searchParams,
    asPath,
    locale,
    pathnameWithoutLocale: (pathname || '').replace(new RegExp(`^/${locale}/?`), '/'),
    asPathWithoutLocale: asPath.replace(new RegExp(`^/${locale}/?`), '/')
  }
}
